import React from "react";

import "./Home.css";
import Nav from "../Navbar/Nav";
import About from "../About/About";
import Project from "../Projects/Project";
import Skills from "../Skills/Skills";
import Contact from "../Contact/Contact";
import Work from "../Work/Work";
import Portfolio from "../portfolio";

function Home() {
  return (
    <div className="home">
      {/*Navbar */}
      <Nav />
      {/*About */}
      <section id="about">
        <About />
      </section>
      {/*Skills */}
      <section id="skills">
        {" "}
        <Skills />
      </section>
      {/*Projects */}
      <section id="project">
        {" "}
        <Portfolio />{" "}
      </section>
      {/* Work*/}
      <section id="work">
        <Work />
      </section>
      {/*Contact */}

      <section id="contact">
        <Contact />
      </section>
    </div>
  );
}

export default Home;
